import React from 'react';
import { useIntl } from 'react-intl';
import './GuestShareModal.scss';
import { GuestShareForm, GuestShareFormData } from './GuestShareForm';
import { FormikProps } from 'formik/dist/types';
import { Formik } from 'formik';
import { GenericMessages } from 'src/intl/GenericMessages';
import { JobMessages } from 'src/intl/JobMessages';
import * as yup from 'yup';
import { AppModal } from '../reusable-components/app-modal/AppModal';
import { SHORT_EXPIRATION_IN_DAYS } from '../../models/jobLog';

interface GuestShareFormProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
  /**
   * Triggers when a form is submitted.
   */
  onSubmit: (values: GuestShareFormData) => Promise<void>;
}

const handleSubmit = (formikProps: FormikProps<GuestShareFormData>) => {
  formikProps.handleSubmit();
};

export const GuestShareModal: React.FC<GuestShareFormProps> = ({ onClose, isOpen, onSubmit }) => {
  const { formatMessage } = useIntl();
  const validationSchema = yup.object({
    firstName: yup.string().required(formatMessage(GenericMessages.fieldRequiredLabel)),
    lastName: yup.string().required(formatMessage(GenericMessages.fieldRequiredLabel)),
    emailAddress: yup
      .string()
      .required(formatMessage(GenericMessages.fieldRequiredLabel))
      .email(formatMessage(GenericMessages.emailAddressInvalidMessage)),
  });

  return (
    <Formik
      initialValues={{
        firstName: '',
        lastName: '',
        emailAddress: '',
        externalOrgName: '',
        daysToExpiration: SHORT_EXPIRATION_IN_DAYS.toString(),
        tubes: true,
        annotations: true,
        timestamps: true,
        pressure: true,
        pieCharts: true,
        idleVsPressure: true,
        configurations: true,
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formikProps: FormikProps<GuestShareFormData>) => (
        <form onSubmit={formikProps.handleSubmit}>
          <AppModal
            className={'guest-share-modal'}
            isOpen={isOpen}
            title={formatMessage(JobMessages.shareReport)}
            onClose={() => {
              onClose();
              formikProps.resetForm();
            }}
            primaryButton={{
              label: formatMessage(JobMessages.shareReport),
              onClick: () => handleSubmit(formikProps),
            }}
            secondaryButton={{
              label: formatMessage(GenericMessages.cancelButtonLabel),
              onClick: () => {
                onClose();
                formikProps.resetForm();
              },
            }}
          >
            <GuestShareForm formikProps={formikProps} />
          </AppModal>
        </form>
      )}
    </Formik>
  );
};
export default GuestShareModal;
